import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"

const arr = Array.from({ length: 10 }, (_, i) => i + 1)

const CoreDeviceDetailsSkeleton = (): ReactElement => (
    <Stack
        spacing={GRID_SPACING * 2}
        data-testid="core-device-details-skeleton"
    >
        {arr.map((i) => (
            <AppSkeleton key={i} height={60} />
        ))}
    </Stack>
)

export default CoreDeviceDetailsSkeleton
